import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "रचनात्मक",
  icon: "✨",
  templates: [
    {
      title: "सोने की कहानी",
      content: `एक छोटे बच्चे के लिए एक कोमल सोने की कहानी लिखें, जो ज़ोर से पढ़ने के लिए उपयुक्त हो।
- मुख्य पात्र एक [दयालु छोटी लोमड़ी] है जिसका नाम [हेज़ल] है।
- कहानी [एक आरामदायक वन गाँव में होती है जहाँ रात को लालटेन जलती हैं]।
- पात्र एक छोटी, शांत चुनौती का सामना करती है: [वह बादलों भरे आसमान में अपना पसंदीदा तारा नहीं ढूंढ पाती, इसलिए वह जुगनुओं के पीछे एक पहाड़ी की चोटी तक जाती है]।
- एक शांतिपूर्ण समाधान के साथ समाप्त करें जो सिखाए [धैर्य रखना और विश्वास करना कि अच्छी चीज़ें वहाँ हैं, भले ही आप उन्हें देख न सकें]।
- छोटे, लयबद्ध वाक्यों का उपयोग करें जो ज़ोर से पढ़ने पर स्वाभाविक लगें।`
    },
    {
      title: "लघु कथा वर्णन",
      content: `ऑडियोबुक शैली की कथावाचन के लिए उपयुक्त एक लघु कथा लिखें।
- शैली: [समकालीन रहस्य]।
- नायक है [एक सेवानिवृत्त पुस्तकालयाध्यक्ष जो नए पड़ोसी की दैनिक दिनचर्या में कुछ अजीब नोटिस करती है]।
- केंद्रीय तनाव है [छोटे, अस्पष्टीकृत विवरण जो एक आश्चर्यजनक लेकिन संतोषजनक खुलासे की ओर ले जाते हैं]।
- स्वर: [शांत सस्पेंस जिसमें गर्माहट के स्पर्श हैं]।
- श्रोता को जोड़े रखने के लिए विभिन्न लंबाई के वाक्यों के साथ स्पष्ट, प्रवाहमय शैली में लिखें।`
    },
    {
      title: "कविता पाठ",
      content: `एक ऐसी कविता लिखें जो ज़ोर से सुनाने के लिए बनी हो।
- विषय: [भोर में एक शहर के जागने की अनुभूति]।
- शैली: [मुक्त छंद जिसमें प्राकृतिक बोलचाल की लय हो]।
- मनोदशा: [चिंतनशील और आशावान]।
- जीवंत संवेदी विवरण शामिल करें: [पहली बस की आवाज़, गीली सड़क पर पड़ती रोशनी, बेकरी से ताज़ी रोटी की खुशबू]।
- पाठक की गति और साँस को निर्देशित करने वाले विराम और पंक्ति विभाजन का उपयोग करें।`
    }
  ]
};
